// Copyright 2025. WebPros International GmbH. All rights reserved.
import * as React from 'react';

import {
    Icon as UIIcon,
    IconName,
} from '@plesk/ui-library';

import { ReactComponent as DisasterRecoveryIcon } from 'common/icons/disaster-recovery.svg';
import { ICONS as UI_ICONS } from 'common/constants';

export enum Icons {
    DISASTER_RECOVERY = 'disaster-recovery',
}

export const ICONS = {
    [Icons.DISASTER_RECOVERY]: DisasterRecoveryIcon,
};

export interface IIconProps extends React.ComponentProps<typeof UIIcon> {
    name?: UI_ICONS | IconName | Icons | string;
}

export function Icon({ name, ...props }: IIconProps) {
    if (typeof name === 'string' && ICONS[name]) {
        const IconComponent = ICONS[name];
        return (
            <UIIcon
                {...props}
            >
                <IconComponent/>
            </UIIcon>
        );
    }

    return (
        <UIIcon
            name={name}
            {...props}
        />
    );
}